import QRCode from 'qrcode';

const STORAGE_KEY = 'simpl-poi-url-qr';
const QR_SIZE = 200;
const QR_OPTIONS = { width: QR_SIZE, errorCorrectionLevel: 'H' as const };

function loadCache(): Record<string, string> {
	try {
		const raw = localStorage.getItem(STORAGE_KEY);
		return raw ? JSON.parse(raw) : {};
	} catch {
		return {};
	}
}

function saveCache(cache: Record<string, string>): void {
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
	} catch {
		// quota or other storage error
	}
}

export function isValidPoiUrl(url: unknown): boolean {
	if (typeof url !== 'string' || !url.trim()) return false;
	try {
		const u = new URL(url.trim());
		return u.protocol === 'http:' || u.protocol === 'https:';
	} catch {
		return false;
	}
}

export function getCachedQrForUrl(url: string): string | null {
	const cache = loadCache();
	return cache[url] ?? null;
}

export function setCachedQrForUrl(url: string, dataUrl: string): void {
	const cache = loadCache();
	cache[url] = dataUrl;
	saveCache(cache);
}

/**
 * Returns a data URL for the QR code of the given URL.
 * Uses localStorage cache so the same URL is not regenerated.
 */
export async function getOrGenerateQrForUrl(url: string): Promise<string | null> {
	const normalized = url.trim();
	if (!isValidPoiUrl(normalized)) return null;

	const cached = getCachedQrForUrl(normalized);
	if (cached) return cached;

	try {
		const dataUrl = await QRCode.toDataURL(normalized, QR_OPTIONS);
		setCachedQrForUrl(normalized, dataUrl);
		return dataUrl;
	} catch {
		return null;
	}
}
